
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../Auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { serverUrl } from '../../Constant/Static/config';
import Loader from '../../Constant/Custom/Loader';

function AllotmentPage() {
  const { auth } = useContext(AuthContext);
  const [allotments, setAllotments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [csrfToken, setCsrfToken] = useState('');
  const [downloading, setDownloading] = useState(false);
  const navigate = useNavigate();
  const [downloadingIndex, setDownloadingIndex] = useState(null);


  const handleDownload = async (allotCollCode, allotBranch, index) => {
    setDownloadingIndex(index);

    try {
      const storedUser = auth.user;
      const response = await axios.post(
        `${serverUrl}/api/user/doc/generate-provisional-allotment`,
        {
          appNo: storedUser.appno,
          loginType: localStorage.getItem('typeuser'),
          allotcollcode: allotCollCode,
          allotbranch: allotBranch,
        },
        { responseType: 'blob' }
      );

      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Allotment Order - ${storedUser.appno}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download error:', error);
    } finally {
      setDownloadingIndex(null);
    }
  };
useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true,
        });
        setCsrfToken(response.data.csrfToken);
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    fetchCsrfToken();
  }, []);

  useEffect(() => {
    const checkSession = async () => {
      setLoading(true);
      try {
        const storedUser = auth.user;

        if (!storedUser || !storedUser.appno || !storedUser.mobile || !storedUser.email) {
          throw new Error('Invalid or incomplete session');
        }

        const isSpecialUser = localStorage.getItem('typeuser') === 'special';
        const endpoint = isSpecialUser
          ? `${serverUrl}/api/user/allotment/special`
          : `${serverUrl}/api/user/allotment`;

        const response = await axios.post(
          endpoint,
          {
            appno: storedUser.appno,
            mobile: storedUser.mobile,
            email: storedUser.email,
          },
          {
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          }
        );

        if (response.status === 200 && Array.isArray(response.data)) {
          setAllotments(response.data);
        } else {
          throw new Error('Failed to load allotment data');
        }
      } catch (error) {
        console.error('Error during session validation:', error);
        setError(error.message);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, [auth, csrfToken, navigate]);

  if (loading) return <Loader />;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className='homePage'>
      <div className='welcomeApplicant'>
        {allotments.length > 0 ? (
          <>
            <h3 style={{ textAlign: 'center', fontSize: '40px', borderBottom: '2px solid gray', paddingBottom: '10px' }}>
              Provisional Allotment
            </h3>
            <h1>{allotments[0].userName}</h1>
            <div>
              <p><b>Application No: </b>{allotments[0].appno}</p>
              <p><b>Email ID: </b>{allotments[0].email}</p>
            </div>
          </>
        ) : (
          <div>No user data available</div>
        )}
      </div>

      <div style={{ margin: '10px' }}>
        <table className='choose-table'>
          <thead>
            <tr>
              <th>ALLOTTED COLLEGE CODE</th>
              <th>ALLOTTED COLLEGE NAME</th>
              <th>ALLOTTED BRANCH</th>
              <th>ALLOTMENT ORDER</th>
            </tr>
          </thead>
          <tbody>
            {allotments.map((user, index) => (
              <tr key={index}>
                <td>{user.allotCollCode}</td>
                <td>{user.allotInst}</td>
                <td>{user.allotBranch}</td>
                <td>
                  {downloadingIndex === index ? (
                    <p>Downloading..!</p>
                  ) : (
                    <button
                      className='btn btn-primary bg-primary'
                      onClick={() => handleDownload(user.allotCollCode, user.allotBranch,index)}
                    >
                      Download
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}




export default AllotmentPage;